//const url_produccion = "https://gateway.penalolen.cl:9443/";
const url_produccion = "https://gsv-oirsdigital.penalolen.cl/p.php/";
//const url_produccion = "https://desarrollo-gsv-oirs.penalolen.cl/p.php/";
const url_produccion_neighbour = "https://gsv-oirsdigital.penalolen.cl/pneighbour.php/";
//const url_produccion_neighbour = "https://desarrollo-gsv-oirs.penalolen.cl/pneighbour.php/";
const url_produccion_general = "https://gsv-oirsdigital.penalolen.cl/pgeneral.php/";
//const url_produccion_general = "https://desarrollo-gsv-oirs.penalolen.cl/pgeneral.php/";
const url_produccion_token = "https://gsv-oirsdigital.penalolen.cl/p_token.php/";
//const url_produccion_token = "https://desarrollo-gsv-oirs.penalolen.cl/p_token.php/";

const url_desarrollo =
  window.location.protocol + "//" + window.location.host + "/";

const produccion = true;

function url_ws(tipo = "") {
  switch (tipo) {
    case "neighbour":
      return url_produccion_neighbour;
      break;
    case "general":
      return url_produccion_general;
    default:
      return produccion == true ? url_produccion : url_produccion;
  }
}

/**OIRS */
/**VALIDAR LOGIN CLAVE UNICA*/
export async function validarLogin(payload) {
  let url='https://gateway-general.penalolen.cl:9443/cu-access-log/search-token';
  if(produccion){
     url = url_produccion_token+"cu-access-log/search-token";
  }else{
     url =
    "https://gateway-general.penalolen.cl:9443/cu-access-log/search-token";
  }

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return response;
}
/**END OIRS */

/**LOGIN */
export async function loginApi(run, password) {
  const url = url_ws() + "users";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      run: run,
      password: password,
      application: "contrataciones",
    }),
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return response;
}

/**VEC_CU01 */
export async function crearVecino(payload) {
  const url = url_ws("neighbour") + "neighbour";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return response;
}

/**VEC_CU04*/
export async function buscarVecinoRut(rut) {
  const url = url_ws("neighbour") + "neighbour/" + rut + "/run";
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    if (response.status === 200) {
      try {
        const respuesta = await response.json();
        return { status: true, datos: respuesta };
      } catch (error) {
        return { status: false, errores: ["No existe vecino asociado al rut"] };
      }
    } else {
      return { status: false, errores: ["Error no especificado"] };
    }
  });
  return response;
}

export async function listadoCalles() {
  const url = url_ws("general") + "geo-street/street-pena";
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    if (response.status === 200) {
      try {
        const respuesta = await response.json();
        return { status: true, datos: respuesta };
      } catch (error) {
        return { status: false, errores: ["Error no especificado"] };
      }
    } else {
      return { status: false, errores: ["Error no especificado"] };
    }
  });
  return response;
}

/**GSV_CU62 */
export async function canalAtencion() {
  const url = url_ws() + "gsv-categories/1/channel";
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    if (response.status === 200) {
      try {
        const respuesta = await response.json();
        return { status: true, datos: respuesta };
      } catch (error) {
        return { status: false, errores: ["Error no especificado"] };
      }
    } else {
      return { status: false, errores: ["Error no especificado"] };
    }
  });
  return response;
}

/**GSV_CU18 */
export async function listadoTematicas(categoria_id = null) {
  const url = url_ws() + "gsv-thematic/" + categoria_id + "/category";
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    if (response.status === 200) {
      try {
        const respuesta = await response.json();
        return { status: true, datos: respuesta };
      } catch (error) {
        return { status: false, errores: ["Error no especificado"] };
      }
    } else {
      return { status: false, errores: ["Error no especificado"] };
    }
  });
  return response;
}

/**GSV_CU19 */
export async function camposTematicas(tematica_id = null) {
  const url = url_ws() + "gsv-definition_form/" + tematica_id + "/thematic";
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    if (response.status === 200) {
      try {
        const respuesta = await response.json();
        return { status: true, datos: respuesta };
      } catch (error) {
        return { status: false, errores: ["Error no especificado"] };
      }
    } else {
      return { status: false, errores: ["Error no especificado"] };
    }
  });
  return response;
}

/**VEC_CU5: Editar datos de Contacto */
export async function editarVecino(payload) {
  //const url = url_ws() + "neighbour/update-contact-information";
  const url = url_ws("neighbour") + "neighbour";
  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return response;
}

/**GSV_CU1: Crear solicitud */
export async function crearSolicitud(payload) {
  const url = url_ws() + "gsv-requests/create";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return response;
}

/**GSV_CU46: Crear antecedentes */
export async function crearAntecedentes(payload) {
  const url = url_ws() + "gsv-antecedents/create";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return response;
}

/**GSV_CU9: Listar por Run*/
export async function solicitudesPorRut(rut = null) {
  const url = url_ws() + "gsv-requests/" + rut + "/list-requests-run";
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    if (response.status === 200) {
      try {
        const respuesta = await response.json();
        return { status: true, datos: respuesta };
      } catch (error) {
        return { status: false, errores: ["Error no especificado"] };
      }
    } else {
      return { status: false, errores: ["Error no especificado"] };
    }
  });
  return response;
}

/**GSV_CU3: Ver solicitud*/
export async function verSolicitud(id_request_neighbor = null) {
  const url = url_ws() + "gsv-requests/" + id_request_neighbor;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    if (response.status === 200) {
      try {
        const respuesta = await response.json();
        return { status: true, datos: respuesta };
      } catch (error) {
        return { status: false, errores: ["Error no especificado"] };
      }
    } else {
      return { status: false, errores: ["Error no especificado"] };
    }
  });
  return response;
}

/**GSV_CU48: Listar antecedentes por solicitud*/
export async function listarAntecedentes(id_request_neighbor = null) {
  const url = url_ws() + "gsv-antecedents/" + id_request_neighbor + "/request";
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    if (response.status === 200) {
      try {
        const respuesta = await response.json();
        return { status: true, datos: respuesta };
      } catch (error) {
        return { status: false, errores: ["Error no especificado"] };
      }
    } else {
      return { status: false, errores: ["Error no especificado"] };
    }
  });
  return response;
}

/**GSV_CU17: Listar derivaciones por Solicitud*/
export async function listarDerivaciones(id_request_neighbor = null) {
  const url = url_ws() + "gsv-derivations/" + id_request_neighbor + "/request";
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    if (response.status === 200) {
      try {
        const respuesta = await response.json();
        return { status: true, datos: respuesta };
      } catch (error) {
        return { status: false, errores: ["Error no especificado"] };
      }
    } else {
      return { status: false, errores: ["Error no especificado"] };
    }
  });
  return response;
}

/**GSV_CU17: Listar derivaciones por Solicitud*/
export async function CU17_detalleDerivacion(id_derivacion = null) {
  const url = `${url_ws()}gsv-derivations/${id_derivacion}/derivation`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    if (response.status === 200) {
      try {
        const respuesta = await response.json();
        return { status: true, datos: respuesta };
      } catch (error) {
        return { status: false, errores: ["Error no especificado"] };
      }
    } else {
      return { status: false, errores: ["Error no especificado"] };
    }
  });
  return response;
}


/** GSV_CUxx: Ver Antecedente */
export async function verAntecedente(id_archivo) {
  const url = `${url_ws()}gsv-antecedents/${id_archivo}/view-doc`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    if (response.status === 200) {
      try {
        const respuesta = await response.json();
        return { status: true, datos: respuesta };
      } catch (error) {
        return { status: false, errores: ["Error no especificado"] };
      }
    } else {
      return { status: false, errores: ["Error no especificado"] };
    }
  });
  return response;
}

/**GSV_CU51: Listar Por Derivación*/
export async function listarDocumentosDerivacion(id_answer_derivation) {
  const url = url_ws() + "gsv-document-answer/"+id_answer_derivation+"/response-derivation";
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return response;
}

/**GSV_CU68: Ver documento Derivación*/
export async function verDocumentoDerivacion(id_doc) {
  const url = url_ws() + "gsv-document-answer/"+id_doc+"/view-doc";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return response;
}

/**GSV_CU10: Acuso Recibo*/
export async function acusoRecibo(payload) {
  const url = url_ws() + "gsv-requests/acknowledge-receipt";
  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return response;
}

/**GSV_CU5: Anular*/
export async function anularSolicitud(payload) {
  const url = url_ws() + "gsv-requests/cancel";
  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return response;
}


//GSV_CU102
///gsv-responses-derivations/32804/derivation
export async function CU102_respuestas_derivacion(id_derivacion) {
  const url = `${url_ws()}gsv-responses-derivations/${id_derivacion}/derivation`;
  const response = await fetch(url, {
    method: "GET"
  }).then(async (response) => {
    if (response.status == 200) {
      try {
        const respuesta = await response.json();
        return { status: true, datos: respuesta };
      } catch (error) {
        return { status: false, errores: ["Error no especificado"] };
      }
    } else {
      return { status: false, errores: ["Error no especificado"] };
    }
  });
  return response;
}